<script setup lang="ts">
import { computed } from 'vue'
import responseCourse from '@/types/requests/course';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const MAX_REGISTER_COURSE_COUNT = 20;

const props = defineProps<{
  modelValue: responseCourse[];
  operationOfficeId: number;
  errorMessages: { [key: string]: string[] };
  windowInnerWidth: number;
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function addCourse(index: number) {
  if (modelValue.value.length >= MAX_REGISTER_COURSE_COUNT) {
    return;
  }
  modelValue.value.splice(index + 1, 0, {
    id: null,
    operation_office_id: props.operationOfficeId ?? null,
    name: '',
  });
}

function removeCourse(index: number) {
  if (modelValue.value.length <= 1) {
    return;
  }
  modelValue.value.splice(index, 1);
}
</script>
<template>
  <div class="mb-4">
    <template
      v-for="(course, index) in modelValue"
      :key="index"
    >
      <v-row
        class="select-form pl-4 pr-3"
      >
        <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3">
          <h6
            v-if="index == 0"
            class="pt-2 pl-4"
          >
            {{ i18n.global.t('pages.operationOffices.form.courseName') }}
          </h6>
        </v-col>
        <v-col
          :cols="props.windowInnerWidth > 800 ? 6 : 9"
          class="d-flex"
        >
          <v-text-field
            v-model="modelValue[index].name"
            :error-messages="props.errorMessages[`courses.${index}.name`]"
            class="mt-0"
          />
        </v-col>
        <v-col
          :cols="props.windowInnerWidth > 800 ? 2 : 3"
          class="d-flex"
        >
          <v-btn
            v-if="index == modelValue.length - 1 && index != (MAX_REGISTER_COURSE_COUNT - 1)"
            class="mb-1 mr-2"
            height="50"
            color="blue-darken-2"
            @click="addCourse(index)"
          >
            <span class="material-symbols-outlined">
              add
            </span>
          </v-btn>
          <v-btn
            v-if="modelValue.length != 1"
            class="mb-1"
            height="50"
            color="danger"
            @click="removeCourse(index)"
          >
            <span class="material-symbols-outlined" style="color: white;">
              delete
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<style>
.select-form .v-label {
  display: none;
}
.select-form .v-field__field {
  padding-top: 7px;
}
</style>
